'use strict';

var m=(...r)=>`${(r?.map(e=>n(e))).join(" ")}`,n=r=>`${Math.round(r/16*1e4)/1e4}rem`;

exports.a = m;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-HIHYWLJZ.js.map